import React from 'react';
import {Checkbox, FormControlLabel, Grid, Typography} from "@mui/material";
import {isZeroPartnerPayout, isZeroSecurSpacePayout} from "../../../util/BookingUtil";
import {styled} from "@mui/material/styles";

const AdminConfirm = styled(Grid)(({theme}) => ({
  backgroundColor: theme.palette.primary.main,
  padding: '1rem',
  borderRadius: '0.57rem',
}));

// Cast back to `typeof Typography` so downstream usage retains Typography's
// polymorphic `component` prop, which `styled()` would otherwise erase.
const FontWhite = styled(Typography)(({theme}) => ({
  color: theme.palette.primary.contrastText,
})) as typeof Typography;

const PayoutConfirmedCheckbox = styled(Checkbox)(({theme}) => ({
  '&.Mui-checked, &.MuiCheckbox-root': {
    color: theme.palette.primary.contrastText,
  }
}));

interface AdminBrokeredBookingConfirmationProps {
  checked?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  customerChargedAmountPerPeriod: number | string;
  partnerPayoutAmountPerPeriod: number | string;
}

const AdminBrokeredBookingConfirmation = ({checked = false, onChange, customerChargedAmountPerPeriod, partnerPayoutAmountPerPeriod}: AdminBrokeredBookingConfirmationProps) => {
  let confirmationMessage = '';

  if (isZeroSecurSpacePayout(customerChargedAmountPerPeriod, partnerPayoutAmountPerPeriod)) {
    confirmationMessage = "SecurSpace payout will be 0";
  } else if (isZeroPartnerPayout(customerChargedAmountPerPeriod, partnerPayoutAmountPerPeriod)) {
    confirmationMessage = "SecurSpace fees are 100%";
  }

  return (
   <AdminConfirm item>
      <FontWhite variant='h5' align='center' component='h6'>Please Confirm</FontWhite>
      <FormControlLabel
        label={<FontWhite variant='body1' component={'strong'}>{confirmationMessage}</FontWhite>}
        control={<PayoutConfirmedCheckbox name='ssPayoutConfirmed' checked={checked} onChange={onChange} />}
      />
   </AdminConfirm>
  );
};

export default AdminBrokeredBookingConfirmation;
